<template>
	<svg
		width="28"
		height="26"
		viewBox="0 0 28 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<title>{{ svgTitle }}</title>
		<path
			v-if="fill === 0"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M17.8482 8.4613L13.933 0.0307617L10.0178 8.4613L0.790039 9.57969L7.5981 15.9084L5.81021 25.0302L13.933 20.511L22.0558 25.0302L20.2679 15.9084L27.076 9.57969L17.8482 8.4613ZM25.8278 9.98524L17.4764 8.97306L13.933 1.34314L10.3896 8.97306L2.03818 9.98524L8.19971 15.713L6.5816 23.9685L13.933 19.8785L21.2844 23.9685L19.6663 15.713L25.8278 9.98524Z"
			fill="#DBCF60"
		/>
		<template v-else-if="fill === 1">
			<path
				class="star-fill"
				d="M13.933 0.000366211L17.8482 8.43091L27.076 9.5493L20.2679 15.878L22.0558 24.9998L13.933 20.4806L5.81021 24.9998L7.5981 15.878L0.790039 9.5493L10.0178 8.43091L13.933 0.000366211Z"
				fill="#EDE06A"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M17.8482 8.43091L13.933 0.000366211L10.0178 8.43091L0.790039 9.5493L7.5981 15.878L5.81021 24.9998L13.933 20.4806L22.0558 24.9998L20.2679 15.878L27.076 9.5493L17.8482 8.43091ZM25.8278 9.95484L17.4764 8.94266L13.933 1.31274L10.3896 8.94266L2.03818 9.95484L8.19971 15.6826L6.5816 23.9381L13.933 19.8481L21.2844 23.9381L19.6663 15.6826L25.8278 9.95484Z"
				fill="#C4B958"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M13.9328 0L14.4283 13.1377L27.0761 9.54915L14.7346 14.0802L22.0558 25L13.9328 14.6627L5.80984 25L13.1311 14.0802L0.789551 9.54915L13.4373 13.1377L13.9328 0Z"
				fill="#C4B958"
			/>
		</template>
		<template v-else-if="fill === 0.5">
			<path
				class="star-fill"
				d="M13.933 0.0157471V7.34889V11.2947V13.6985V17.1907V20.496L5.81021 25.0152L7.5981 15.8934L0.790039 9.56468L10.0178 8.44629L13.933 0.0157471Z"
				fill="#EDE06A"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M17.8482 8.44629L13.933 0.0157471L10.0178 8.44629L0.790039 9.56468L7.5981 15.8934L5.81021 25.0152L13.933 20.496L22.0558 25.0152L20.2679 15.8934L27.076 9.56468L17.8482 8.44629ZM25.8278 9.97022L17.4764 8.95804L13.933 1.32812L10.3896 8.95804L2.03818 9.97022L8.19971 15.698L6.5816 23.9534L13.933 19.8634L21.2844 23.9534L19.6663 15.698L25.8278 9.97022Z"
				fill="#C4B958"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M13.9328 0.0153809L13.9328 13.153V14.678L5.80984 25.0154L13.1311 14.0955L0.789551 9.56453L13.4373 13.153L13.9328 0.0153809Z"
				fill="#C4B958"
			/>
		</template>
	</svg>
</template>

<script lang="ts" setup>
const props = defineProps<{
	fill: number;
}>();

const svgTitle = computed(() => {
	if (props.fill === 0.5) {
		return 'halve ster';
	}
	else if (props.fill === 1) {
		return 'hele ster';
	}

	return 'lege ster';
});
</script>

<style lang="postcss" scoped>
@keyframes star-glow {
    0% {
        filter: drop-shadow(0 0 1px theme('colors.yellow.200'));
    }

    50% {
        filter: drop-shadow(0 0 3px theme('colors.yellow.400'));
    }

    100% {
        filter: drop-shadow(0 0 1px theme('colors.yellow.200'));
    }
}

.star-fill {
    animation: star-glow 4s ease-in-out infinite;
    filter: drop-shadow(0 0 1px theme('colors.yellow.300'));
}
</style>
